export enum Errors {
  sessionExpired = "sessionExpired",
  requireLogin = "requireLogin",
  unexpectedError = "unexpectedError",
  reputationsDeclined = "reputationsDeclined",
  endorsementExisted = "endorsementExisted",
}
